<template>
  <component
    ref="editReservation"
    :is="currentComponent"
    :key="`${purchaseType}-${$route.path}`"
  ></component>
</template>
<script>
import { mapGetters } from "vuex";
const EditTransfers = () =>
  import("@/modules/reservations/pages/transfers/EditTransfers.vue");
const EditExperiences = () =>
  import("@/modules/reservations/pages/experiences/EditExperiences.vue");

export default {
  computed: {
    ...mapGetters(["purchaseType"]),
    currentComponent() {
      return this.purchaseType === "TRANSFER_RESERVATION"
        ? EditTransfers
        : EditExperiences;
    }
  },
  beforeRouteLeave(to, from, next) {
    const child = this.$refs["editReservation"];
    if (child && typeof child.detectChanges === "function") {
      child.detectChanges(to, from, next);
    } else {
      next();
    }
  }
};
</script>
